import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Label from "semantic-ui-react/dist/es/elements/Label/Label"

const AppHeader = ({ children, logo, env }) => {
  const validChildren = React.Children.toArray(children).filter(child => child)
  return (
    <Grid.Row columns="equal" style={{ marginTop: "1em" }}>
      {logo ? (
        <Grid.Column>
          {logo}
          {env != null ? (
            <Label
              content={env}
              color="red"
              size="mini"
              style={{ marginLeft: "1em" }}
            />
          ) : null}
        </Grid.Column>
      ) : null}
      {React.Children.map(validChildren, (child, index) => (
        <Grid.Column
          verticalAlign="bottom"
          textAlign={
            index === React.Children.toArray(children).length - 1
              ? "right"
              : "center"
          }
        >
          {child}
        </Grid.Column>
      ))}
    </Grid.Row>
  )
}

export default AppHeader
